/* eslint-disable import/prefer-default-export */
import { Box, BoxProps, Flex, FlexProps } from "@chakra-ui/react";
import {
  RetailerCategoryReviewOption,
  RetailerPricingStrategyOption,
  RetailerSlottingRequiredOption,
} from "__generated__/gql/graphql";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import RetailerFlagIcons from "components/Shared/RetailerDirectory/RetailerFlagIcons";
import NameWithSuffix from "components/Shared/RetailerDirectory/NameWithSuffix";

const fragment = gql(/* GraphQL */ `
  fragment RetailerNameWithFlagIconsFragment on Retailer {
    ...RetailerNameWithSuffixFragment
    ...RetailerFlagIcons
  }
`);

type NameWithFlagIconsProps = Omit<FlexProps, "noOfLines"> & {
  nameProps?: BoxProps;
  noOfLines?: number;
  retailer: FragmentType<typeof fragment> | undefined | null;
};

export function NameWithFlagIcons({
  children,
  nameProps,
  noOfLines = 2,
  retailer: retailerFragment,
  ...rest
}: NameWithFlagIconsProps) {
  const retailer = getFragmentData(fragment, retailerFragment);
  return (
    <Flex flexFlow="row" alignItems="center" minW={0} gap={1} {...rest}>
      <Box
        as="span"
        display="inline-block"
        noOfLines={noOfLines === Infinity ? undefined : noOfLines}
        {...nameProps}
      >
        <NameWithSuffix retailer={retailer} />
      </Box>
      {retailer && <RetailerFlagIcons data={retailer} />}
      {children}
    </Flex>
  );
}

export const slottingOptionsMap: Record<
  RetailerSlottingRequiredOption,
  string
> = {
  [RetailerSlottingRequiredOption.NO]: "No",
  [RetailerSlottingRequiredOption.YES]: "Yes",
  [RetailerSlottingRequiredOption.YES_EXC]: "Yes (with exceptions)",
};

export const slottingOptions = [
  RetailerSlottingRequiredOption.NO,
  RetailerSlottingRequiredOption.YES,
  RetailerSlottingRequiredOption.YES_EXC,
];

export const pricingStrategyMap: Record<RetailerPricingStrategyOption, string> =
  {
    [RetailerPricingStrategyOption.EDLP]: "Everyday Low Price",
    [RetailerPricingStrategyOption.HIGH_LOW]: "High/Low",
    [RetailerPricingStrategyOption.VALUE]: "Value",
  };

export const pricingStrategies = [
  RetailerPricingStrategyOption.EDLP,
  RetailerPricingStrategyOption.HIGH_LOW,
  RetailerPricingStrategyOption.VALUE,
];

export const retailerCategoryReviewMap: Record<
  RetailerCategoryReviewOption,
  string
> = {
  [RetailerCategoryReviewOption.LOOSE]: "Loose Schedule",
  [RetailerCategoryReviewOption.OPEN]: "Open Review",
  [RetailerCategoryReviewOption.STRICT]: "Strict Schedule",
};

export const retailerCategories = [
  RetailerCategoryReviewOption.LOOSE,
  RetailerCategoryReviewOption.OPEN,
  RetailerCategoryReviewOption.STRICT,
];
